export default "__VITE_ASSET__501277bb__"